import React, { useState, useEffect } from "react";
import axios from "axios";
import AdminTeamManagementstyle from "../AdminStyles/AdminTeamManagementstyle.module.css";
import Frame from "../../icons/Frame.svg";
import Trashcan from "../../icons/Trash can.svg"; // Update the import if the file name has changed
import Link from "../../icons/Link.svg"; // Update the import if the file name has changed
import SpinnerIcon from "../../icons/spinner.svg"; // Add spinner icon import
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Modal from "react-modal";

Modal.setAppElement("#root");

const AdminTeamManagement = () => {
  const [MyTeams, setMyTeams] = useState([]);
  const [teams, setTeams] = useState([]);
  const [newPromoterUsername, setNewPromoterUsername] = useState("");
  const [newPromoterDisplayName, setNewPromoterDisplayName] = useState("");
  const [activeDays, setActiveDays] = useState([]);
  const [activeDaysPromoteurStats, setActiveDaysPromoteurStats] = useState([]);
  const [startDate, setstartDate] = useState(dayjs());
  const [endDate, setendDate] = useState(dayjs());
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackMessageType, setFeedbackMessageType] = useState("");
  const [isFetchingPRPerformance, setIsFetchingPRPerformance] = useState(false); // New loading state
  const adminId = localStorage.getItem("adminId"); // or use your context/store if you have one
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  //PR TEAM SECTION ELEMENTS
  function copyToClipboard(text) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        alert("Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  }
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentPromoter, setCurrentPromoter] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deletionLoading, setDeletionLoading] = useState(false);
  const [deletionMessage, setDeletionMessage] = useState("");
  const [deletionMessageType, setDeletionMessageType] = useState("");
  // Fetch team promoters from the backend on component mount
  const customStyles = {
    content: {
      top: "50%",
      left: windowWidth > 900 ? "60%" : "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      backgroundColor: "#F0F0F0",
      borderRadius: "2%",
      transform: "translate(-50%, -50%)",
      width: windowWidth < 700 ? "80%" : "60%",
      height: "auto"
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    }
  };
  const handleStartDateChange = (newValue) => {
    setstartDate(newValue);
    if (newValue.isAfter(endDate)) {
      setendDate(newValue); // Set end date to new start date if it's later than the current end date
    }
  };

  const handleEndDateChange = (newValue) => {
    setendDate(newValue);
    if (newValue.isBefore(startDate)) {
      setstartDate(newValue); // Set start date to new end date if it's earlier than the current start date
    }
  };

  useEffect(() => {
    const fetchPromoters = async () => {
      try {
        let token = localStorage.getItem("token");
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/admin/team/${adminId}`,
          {
            headers: {
              authorization: `Bearer ${token}`
            }
          }
        );
        console.log("Console.log(promotersData)", response.data.promotersData);

        setMyTeams(response.data.promotersData);
      } catch (error) {
        console.error("Error fetching promoters:", error);
      }
    };
    fetchPromoters();
  }, [adminId]);

  // Function to handle adding a new promoter
  const handleAddPromoter = async (e) => {
    e.preventDefault();
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/add_promoter_team/${adminId}`,
        {
          username: newPromoterUsername,
          display_name: newPromoterDisplayName,
          daysOfWeek: activeDays
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      setTeams(response.data.promotersData);
      setNewPromoterUsername("");
      setNewPromoterDisplayName("");
      setActiveDays([]);
      // Set success message
      setFeedbackMessage("Promoter added successfully to the team.");
      setFeedbackMessageType("success");
    } catch (error) {
      console.error("Error adding new promoter:", error);
      // Set error message from the response or a generic error message
      const message =
        error.response?.data?.message ||
        "Failed to add new promoter. Please try again.";
      setFeedbackMessage(message);
      setFeedbackMessageType("error");
    }
  };

  // Function to handle day toggling for new promoters
  const toggleDay = (day) => {
    setActiveDays((current) =>
      current.includes(day)
        ? current.filter((d) => d !== day)
        : [...current, day]
    );
  };
  const toggleDayPromoteurStats = (day) => {
    setActiveDaysPromoteurStats((current) =>
      current.includes(day)
        ? current.filter((d) => d !== day)
        : [...current, day]
    );
  };

  const GetPromotersTableData = async () => {
    setIsFetchingPRPerformance(true); // Set loading state to true
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/promoters-stats/`,
        {
          adminId: adminId, // Replace with actual adminId or retrieve it from context/state
          period: {
            start: startDate.format("YYYY-MM-DD"),
            end: endDate.format("YYYY-MM-DD")
          },
          weekDays: activeDaysPromoteurStats
        },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      if (response.data && Array.isArray(response.data)) {
        // Sort the data
        const sortedData = response.data.sort((a, b) => {
          // Sort by revenue (descending)
          if (a.revenue !== b.revenue) {
            return b.revenue - a.revenue;
          }
          // If revenue is equal, sort by totalReferrals (descending)
          if (a.totalReferrals !== b.totalReferrals) {
            return b.totalReferrals - a.totalReferrals;
          }
          // If totalReferrals is also equal, sort by scannedReferrals (descending)
          return b.scannedReferrals - a.scannedReferrals;
        });

        // Update state with sorted data
        setTeams(sortedData);
      }
    } catch (error) {
      console.error("Failed to fetch promoters data:", error);
    } finally {
      setIsFetchingPRPerformance(false); // Set loading state to false
    }
  };

  const PromotersTable = ({ PromotersTableData }) => {
    if (!PromotersTableData) {
      return null;
    }
    return (
      <table>
        <thead>
          <tr>
            <th>Promoters</th>
            <th>Total Referrals</th>
            <th>Scanned Referrals</th>
            <th>Revenue</th>
          </tr>
        </thead>
        <tbody>
          {PromotersTableData.map((promoter) => (
            <tr key={promoter.id}>
              <td>
                <div className={AdminTeamManagementstyle.promoterDetail}>
                  {/*<img
                    src={promoter.image || "defaultProfileImage.png"}
                    alt="Promoter"
                    className={AdminTeamManagementstyle.promoterImage}
                  />*/}
                  <span>{promoter.promoterName}</span>
                </div>
              </td>
              <td>{promoter.totalReferrals}</td>
              <td>{promoter.scannedReferrals}</td>
              <td>{promoter.revenue}</td>
              <td>
                <div className={AdminTeamManagementstyle.actionButtons}>
                  <button
                    onClick={() => {
                      setCurrentPromoter({
                        id: promoter.id,
                        PRname: promoter.PRname
                      });
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <img src={Trashcan} alt="Delete" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  // Function to delete a promoter
  const handleDeletePromoter = async (promoterId, displayName) => {
    setDeletionLoading(true);
    try {
      let token = localStorage.getItem("token");
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/admin/remove_promoter_team/${adminId}`,
        {
          data: { user_id: promoterId, display_name: displayName },
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        setDeletionMessage("Promoter deleted successfully.");
        setDeletionMessageType("success");
        // Update the teams state to reflect the deletion

        const updatedTeams = MyTeams.filter(
          (promoter) => promoter.id !== promoterId
        );
        console.log("updatedTeams: ", updatedTeams);
        setMyTeams(updatedTeams);
      } else {
        throw new Error("Failed to delete the promoter");
      }
    } catch (error) {
      console.error("Error deleting promoter:", error);
      setDeletionMessage("Failed to delete promoter. Please try again.");
      setDeletionMessageType("error");
    } finally {
      setDeletionLoading(false);
    }
  };

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
  ];

  // SERACH COMPONENT
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = async () => {
    setSearchResults([]);
    try {
      let token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/admin/searchClubOwners`,
        { searchName: searchQuery, adminId: adminId },
        {
          headers: {
            authorization: `Bearer ${token}`
          }
        }
      );
      console.log("response: ", response);
      setSearchResults(response.data.clubOwners);
    } catch (error) {
      console.error("Error searching for organizations:", error);
      // Handle error appropriately, e.g., setting an error message in the UI
    }
  };

  const SearchResultsComponent = () => {
    console.log("searchResults: ", searchResults);
    if (!searchResults.length) {
      return <p>No results found</p>;
    }
    return (
      <div>
        {searchResults.map((org) => (
          <div key={org._id}>
            <h3>{org.name}</h3>
            <p>{org.collaborationStatus}</p>
            {/* Additional organization details */}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={AdminTeamManagementstyle.adminTeamManagement}>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={() => {
          if (!deletionLoading) {
            setIsDeleteModalOpen(false);
            setDeletionMessage(""); // Clear any previous deletion messages
            setDeletionMessageType(""); // Reset the message type
          } else {
            alert(
              "Deletion in progress. Please wait until the operation is complete."
            );
          }
        }}
        style={customStyles}
        contentLabel="Confirm Deletion"
      >
        <h2>Confirm Deletion</h2>
        <p>
          Are you sure you want to delete {currentPromoter?.PRname}? This action
          cannot be undone, and the promoter will no longer be able to promote
          any events. All data about their collaboration will be erased.
        </p>
        {deletionLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <img src={SpinnerIcon} alt="Loading" style={{ width: "50px" }} />
          </div>
        ) : deletionMessage ? (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <p
              style={{
                color: deletionMessageType === "error" ? "red" : "green"
              }}
            >
              {deletionMessage}
            </p>
            <button
              style={{
                padding: "10px 20px",
                borderRadius: "5px",
                backgroundColor: "#f1faee",
                color: "#1d3557",
                cursor: "pointer",
                border: "none"
              }}
              onClick={() => {
                setIsDeleteModalOpen(false);
                setDeletionMessage("");
                setDeletionMessageType("");
              }}
            >
              Close
            </button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              marginTop: "20px"
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                borderRadius: "5px",
                backgroundColor: "#e63946",
                color: "white",
                cursor: "pointer",
                border: "none"
              }}
              onClick={() =>
                handleDeletePromoter(currentPromoter.id, currentPromoter.PRname)
              }
            >
              Confirm
            </button>
            <button
              style={{
                padding: "10px 20px",
                borderRadius: "5px",
                backgroundColor: "#f1faee",
                color: "#1d3557",
                cursor: "pointer",
                border: "none"
              }}
              onClick={() => {
                setIsDeleteModalOpen(false);
                setDeletionMessage("");
                setDeletionMessageType("");
              }}
            >
              Cancel
            </button>
          </div>
        )}
      </Modal>
      <div className={AdminTeamManagementstyle.header1}>
        <div className={AdminTeamManagementstyle.headerTitle}>
          Launch a new Event!
        </div>
        <button className={AdminTeamManagementstyle.headerButton}>
          <img src={Frame} alt="Launch" />
        </button>
      </div>
      <div className={AdminTeamManagementstyle.gridContainer}>
        <div className={AdminTeamManagementstyle.sectionStyle}>
          <table>
            <thead>
              <tr>
                <th>Promoter</th>
                <th>Name</th>
                <th>Family Name</th>
              </tr>
            </thead>
            <tbody>
              {MyTeams &&
                MyTeams.map((promoter) => (
                  <tr key={promoter.id}>
                    <td>
                      <div className={AdminTeamManagementstyle.promoterDetail}>
                        <img
                          src={promoter.image || "default_link_to_image"}
                          alt="Promoter"
                          className={AdminTeamManagementstyle.promoterImage}
                        />
                        <span></span>
                      </div>
                    </td>
                    <td>{promoter.firstName}</td>
                    <td>{promoter.lastName}</td>
                    <td>
                      <div className={AdminTeamManagementstyle.actionButtons}>
                        <button
                          onClick={() =>
                            copyToClipboard(
                              `https://patt.club/promoters.html?promoterName=${encodeURIComponent(promoter.PRname)}`
                            )
                          }
                        >
                          <img src={Link} alt="Copy Link" />
                        </button>
                        <button
                          onClick={() => {
                            setCurrentPromoter({
                              id: promoter.id,
                              PRname: promoter.PRname
                            });
                            setIsDeleteModalOpen(true);
                          }}
                        >
                          <img src={Trashcan} alt="Delete" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className={AdminTeamManagementstyle.cardStyle}>
          <h2>Add New Promoter to Team</h2>
          <div className={AdminTeamManagementstyle.inputField}>
            <label htmlFor="pattUsername">Enter Promoter PATT Username</label>
            <input
              type="text"
              id="pattUsername"
              placeholder="@PATTusername"
              value={newPromoterUsername}
              onChange={(e) => setNewPromoterUsername(e.target.value)}
            />
          </div>
          <div className={AdminTeamManagementstyle.inputField}>
            <label htmlFor="displayName">Enter Promoter Display Name</label>
            <input
              type="text"
              id="displayName"
              placeholder="First Name"
              value={newPromoterDisplayName}
              onChange={(e) => setNewPromoterDisplayName(e.target.value)}
            />
          </div>
          <div className={AdminTeamManagementstyle.selectDays}>
            <label>Select Working Days</label>
            <div className={AdminTeamManagementstyle.daysOfWeek}>
              {daysOfWeek.map((day) => (
                <button
                  key={day}
                  onClick={() => toggleDay(day)}
                  className={`${AdminTeamManagementstyle.dayButton} ${activeDays.includes(day) ? AdminTeamManagementstyle.activeDay : ""}`}
                >
                  {day}
                </button>
              ))}
            </div>
            <button
              className={AdminTeamManagementstyle.addPromoterButton}
              onClick={handleAddPromoter}
            >
              Add Promoter to the Team
            </button>
            {feedbackMessage && (
              <div
                style={{
                  color: feedbackMessageType === "error" ? "red" : "green",
                  marginTop: "10px"
                }}
              >
                {feedbackMessageType === "error"
                  ? "Error: " + feedbackMessage
                  : feedbackMessage}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={AdminTeamManagementstyle.sectionStyle2}>
        <h1>Team Ranking</h1>
        <label>Select Period</label>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "DatePicker"]}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={handleStartDateChange}
            />
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </DemoContainer>
        </LocalizationProvider>
        <br />
        <label>Select Working Days</label>
        <div className={AdminTeamManagementstyle.daysOfWeek}>
          {daysOfWeek.map((day) => (
            <button
              key={day}
              onClick={() => toggleDayPromoteurStats(day)}
              className={`${AdminTeamManagementstyle.dayButton} ${activeDaysPromoteurStats.includes(day) ? AdminTeamManagementstyle.activeDay : ""}`}
            >
              {day}
            </button>
          ))}
        </div>

        <div className={AdminTeamManagementstyle.fetchContainer}>
          <button
            className={AdminTeamManagementstyle.addPromoterButton}
            onClick={GetPromotersTableData}
          >
            Fetch PR Performance
          </button>
          {isFetchingPRPerformance && (
            <div className={AdminTeamManagementstyle.loadingContainer}>
              <img src={SpinnerIcon} alt="Loading" />
              <span>Your PRs performance are fetching...</span>
            </div>
          )}
        </div>
        <br />
        <PromotersTable PromotersTableData={teams} />
      </div>
      <div className={AdminTeamManagementstyle.sectionStyle2}>
        <div className={AdminTeamManagementstyle.inputField}>
          <h1 htmlFor="orgSearch">Search Organizations:</h1>
          <input
            type="text"
            id="orgSearch"
            placeholder="Enter organization name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            className={AdminTeamManagementstyle.addPromoterButton}
            onClick={handleSearch}
          >
            Search
          </button>
        </div>
        {searchResults && <SearchResultsComponent />}
      </div>
    </div>
  );
};

export default AdminTeamManagement;
